export default "__VITE_ASSET__8b55d9a8__"